


















































































import Vue from 'vue'
import { Progress } from 'element-ui'
// @ts-ignore
import ClipLoader from '@/components/vue-spinner/ClipLoader.vue'
import VueImgLoader from 'vue-img-loader'
import VideoPlayer from '@/components/VideoPlayer'
import helpers from '../../../../helpers'
import { Stream } from '@/types/streams'
import { Asset, AssetType, VideoAsset, ClipTranscodingState } from '@/types/assets'
import WidgetThumbnail from '@/components/Widgets/WidgetThumbnail/WidgetThumbnail.vue'
import './AssetPreview.scss'

export default Vue.extend({
  name: 'AssetPreview',
  props: {
    assetId: {
      type: String,
      required: true
    },
    folderId: {
      type: String,
      required: false,
      default: null
    },
    stream: {
      type: Object as () => Stream,
      required: false,
      default: null
    }
  },
  methods: {
    getRandStr () {
      return helpers.makeId()
    },
    showDetails () {
      this.$emit('showDetails')
    }
  },
  data: () => ({
    assetdb: undefined as Asset | undefined
  }),
  mounted () {
    if (this.folderId) {
      this.assetdb = this.$store.direct.state.assets.assetGroupAssets[this.folderId][this.assetId]
    }
  },
  computed: {
    asset (): Asset|Stream {
      if (this.stream) {
        return this.stream
      }
      if (this.folderId && this.assetdb) {
        return this.assetdb
      }
      return this.$store.direct.state.assets.sceneAssets[this.assetId]
    },
    isReady (): boolean {
      if (this.asset.type !== AssetType.Video) {
        return true
      }
      const videoasset = this.asset as VideoAsset
      if (videoasset.state === undefined) {
        return true
      } else {
        return videoasset.state === 'done'
      }
    },
    isError (): boolean {
      if (this.asset.type !== AssetType.Video) {
        return true
      }
      const videoasset = this.asset as VideoAsset
      if (videoasset.state === undefined) {
        return true
      } else {
        return videoasset.state === ClipTranscodingState.Error
      }
    },
    thumbnail (): string {
      if (this.stream) {
        return ''
      }
      const asset = this.asset as Asset
      return (asset.thumbnail && asset.thumbnail !== '') ? asset.thumbnail : '/temp_thumb.png'
    },
    stateName (): string {
      if (this.asset.type !== AssetType.Video) {
        return ''
      }
      const videoasset = this.asset as VideoAsset
      if (videoasset.state === undefined) {
        return ''
      }
      if (videoasset.state === ClipTranscodingState.Transcoding) {
        return 'processing'
      }
      return ClipTranscodingState[videoasset.state]
    }
  },
  components: {
    VideoPlayer,
    'vue-img-loader': VueImgLoader,
    'clip-loader': ClipLoader,
    'el-progress': Progress,
    WidgetThumbnail
  }
})
